import React from "react";
import Select from "react-select";
import {buildRow} from "../../util/FormatUtil";
import {isBlank, isOnlyWhitespace} from "../../util/ValidationUtil";
import {sweetalert} from "../../App";
import {isEmptyObject} from "jquery";
import moment from "moment";
import JSONPretty from 'react-json-pretty';
import Batch from "../../types/Batch";
import TestsAPI from "../../network/TestsAPI";
import {CustomFieldBuilder} from '../../customfields/CustomFieldBuilder' 
import GetField from "../../customfields/GetField";
import ServicesAPI from "../../network/ServicesAPI";
import SystemAPI from "../../network/SystemAPI";
import BatchesAPI from "../../network/BatchesAPI";

interface BatchManagementState {
    selectedBatch:Batch
    ServiceType?
    ServiceTypeOptions:{label, value:number}[]
    customFieldData?
    batchSamples?
}

interface BatchManagementModalProps {
    onSubmit:(batch) => void
    selectedBatch:Batch
    pageCustomQuestions?
}

export class BatchManagementModal extends React.Component<BatchManagementModalProps, BatchManagementState>{
    public static ID = "batchmanagement";

    constructor(props) {
        super(props);
        this.state = {
            selectedBatch: {
                ID: null,
                BatchNum:"",
                ServiceID:null,
                ResultApprovedDate:null,
                ResultApprovedBy:"",
                ExportUploadedBy:"",
                MachineData:null,
                Notes:"",
                CustomFieldData: null
            } as Batch,
            ServiceType: {label: "", value: null},
            ServiceTypeOptions: []
        }
    }

    componentWillReceiveProps(nextProps: Readonly<BatchManagementModalProps>, nextContext: any) {
        if(!isEmptyObject(nextProps.selectedBatch)){
            let batch = nextProps.selectedBatch;

            BatchesAPI.getSamplesByBatchID(batch.ID).then(res =>{
                this.setState({batchSamples:res.samples})
            })


            this.setState({
                selectedBatch: {
                    ID: batch.ID,
                    BatchNum: batch.BatchNum,
                    ServiceID: batch.ServiceID,
                    ResultApprovedDate: batch.ResultApprovedDate ? new Date(batch.ResultApprovedDate) : '',
                    ResultApprovedBy: batch.ResultApprovedBy,
                    Notes: batch.Notes,
                    ExportUploadedBy: batch.ExportUploadedBy,
                    MachineData: batch.MachineData,
                    CustomFieldData: nextProps.selectedBatch && nextProps.selectedBatch.CustomFieldData ? JSON.parse(nextProps.selectedBatch.CustomFieldData) : null,
                    CreatedDate: batch.CreatedDate
                } as Batch,
                ServiceType: this.state.ServiceTypeOptions.filter( o => o.value === batch.ServiceID)
            });
        }else{
            this.setState({
               batchSamples: null,
               selectedBatch: {
                   ID: null,
                   BatchNum:"",
                   ServiceID:null,
                   ResultApprovedDate:null,
                   ResultApprovedBy:"",
                   ExportUploadedBy:"",
                   MachineData:null,
                   Notes:"",
                   CustomFieldData: null,
                   CreatedDate: new Date()
               } as Batch,
                ServiceType: {label: "", value: null},
            })
        }
    }

    async componentDidMount() {
        let serviceResponse = await ServicesAPI.getAllServicesForMachineExport();
        this.setState({
            ServiceTypeOptions: serviceResponse.data.filter(s => s.IsLabService).map(service => {
                return ({label: service.Name, value: service.ID})
            }),
        })
    }

    render(){
    
        // console.log('Batch Mgmt Modal state', this.state)
        return (
            <div className="modal fade form_modal" id={BatchManagementModal.ID}
                 tabIndex={-1} role="dialog"
                 aria-labelledby="result_modal_label"
                 aria-hidden="true">
                <div className="modal-dialog modal-lg modal-xl" role="document">
                    <div className="modal-content">
                    <div className="container-fluid">
                        <div className="modal-header">
                            <h5 className="modal-title" id="result_modal_label">Batch Management</h5>
                            <button style={{outline: 'none'}}  type="button" className="close" data-dismiss="modal"
                                    aria-label="Close" onClick={()=>
                                this.setState({
                                    selectedBatch:{
                                        ID: null,
                                        BatchNum: "",
                                        ServiceID: null,
                                        ResultApprovedDate: null,
                                        ResultApprovedBy: "",
                                        Notes: "",
                                        ExportUploadedBy: "",
                                        MachineData: null,
                                        CreatedDate: null
                                    } as Batch,
                                    ServiceType: {label: "", value: null}
                                })
                            }>
                                <span aria-hidden="true">&times;</span>
                            </button>

                        </div>
                        <div className="modal-body m-3">
                            { buildRow("Batch Number",
                                <input className={"form-control"}
                                       maxLength={50}
                                       autoComplete={"off"}
                                       type={"search"}
                                       name={"BatchNum"}
                                       onChange={(e)=>{
                                           this.setState( (prevState) => ({
                                               selectedBatch: {
                                                   ...prevState.selectedBatch,
                                                   BatchNum: e.target.value
                                               }
                                           }))
                                       }}
                                       value={this.state.selectedBatch.BatchNum}
                                />
                            )}
                            { buildRow("Service",
                                <Select
                                    isDisabled={this.state.batchSamples && this.state.batchSamples.length > 0 ? true : false}
                                    placeholder={"Please Select..."}
                                    className={"state_select"}
                                    name={"Service"}
                                    options={this.state.ServiceTypeOptions}
                                    onChange={(e)=>{
                                        this.setState( (prevState) => ({
                                            selectedBatch: {
                                                ...prevState.selectedBatch,
                                                ServiceID: e.value
                                            },
                                            ServiceType: e
                                        }))
                                    }}
                                    value={this.state.ServiceType}
                                />
                            )}
                            { this.state.selectedBatch.ID != null ?
                                buildRow("Result Approved Date",
                                    <input className={"form-control"}
                                           maxLength={50}
                                           autoComplete={"off"}
                                           type={"text"}
                                           name={"ResultApprovedDate"}
                                           readOnly={true}
                                           value={this.state.selectedBatch.ResultApprovedDate ? moment(this.state.selectedBatch.ResultApprovedDate, "MM-DD-YYYY").format('MM-DD-YYYY') : ''}
                                    />
                                ): <React.Fragment />
                            }
                            { this.state.selectedBatch.ID != null ?
                                buildRow("Export Uploaded By",
                                    <input className={"form-control"}
                                           maxLength={1000}
                                           autoComplete={"off"}
                                           type={"search"}
                                           name={"ExportUploadedBy"}
                                           readOnly={true}
                                           value={this.state.selectedBatch.ExportUploadedBy}
                                    />
                                ): <React.Fragment />
                            }
                            { buildRow("Notes",
                            <div>
                                <textarea className={"form-control"}
                                          maxLength={1000}
                                          autoComplete={"off"}
                                          name={"Notes"}
                                          onChange={(e)=>{
                                              this.setState( (prevState) => ({
                                                  selectedBatch: {
                                                      ...prevState.selectedBatch,
                                                      Notes: e.target.value
                                                  }
                                              }))
                                          }}
                                          value={this.state.selectedBatch.Notes}
                                />
                                <div className="row pt-1 pr-3 justify-content-end">
                                    <div className={this.state.selectedBatch.Notes && this.state.selectedBatch.Notes.length > 0 ? 'visible' : 'invisible'}>
                                        <div style={{fontSize: '0.8em'}}>{this.state.selectedBatch.Notes && this.state.selectedBatch.Notes.length}/1000</div>
                                    </div>
                                </div>
                </div>
                            )}

                            {/*Custom Field Data*/}

                            {
                                (this.props.pageCustomQuestions)
                                    ?
                                    <div className="row">
                                        {this.props.pageCustomQuestions.map((val, index) => {
                                            if(val.Options.isActive){
                                                return (
                                                    <div className="col-12">
                                                        <div className="form-group row">
                                                            <GetField 
                                                            val={val} 
                                                            selectedItem={this.state.selectedBatch ? this.state.selectedBatch : null} 
                                                            handleChange={(e) => {
                                                                this.setState({selectedBatch: e})
                                                            }}  
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        })}
                                    </div>
                                    :
                                    <div className="invisible"></div>
                            }




                            {/** Display Machine Data for Batches that exist **/}
                            { this.state.selectedBatch.ID != null ?
                                buildRow('Machine Data',
                                    <JSONPretty id='json-pretty'
                                                mainStyle='padding:1em'
                                                data={this.state.selectedBatch.MachineData}
                                    />
                                ) :
                                <React.Fragment />
                            }
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary"
                                    onClick={() => {
                                        if( !this.state.selectedBatch.BatchNum ||
                                            isBlank(this.state.selectedBatch.BatchNum) ||
                                            isOnlyWhitespace(this.state.selectedBatch.BatchNum)
                                        ){
                                            return sweetalert.fire("Attention", "Please enter a Batch Number.", "error")
                                        }
                                        if( !this.state.selectedBatch.ServiceID ){
                                            return sweetalert.fire("Attention", "Please select a Service.","error")
                                        }

                                        let invalid = CustomFieldBuilder.validateCustomFields(this.state.selectedBatch.CustomFieldData, this.props.pageCustomQuestions, this.state.selectedBatch)

                                        if(invalid){
                                            return;
                                        }


                                        this.props.onSubmit(this.state.selectedBatch)
                                    }}>
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        );
    }
}